import React, { useEffect, useState } from 'react'
import ProgramPhaseForm from './form'
import { getProgramPhaseDetailPromise } from 'api/ProgramPhase'

const ProgramPhaseEdit = props => {
  const {
    match: {
      params: { id },
    },
  } = props

  const [data, setData] = useState({})

  useEffect(() => {
    if (!id) return

    getProgramPhaseDetailPromise(id).then(resp => {
      resp && setData({ ...resp })
    })
  }, [id])

  return (
    <div className={'root'}>
      <div className={'content'}>
        <ProgramPhaseForm data={data} setData={setData} {...props} />
      </div>
    </div>
  )
}

export default ProgramPhaseEdit
